export const toNumber = (value) => {
    const parsedValue = Number.parseFloat(value);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const getCandidateTotalScore = (candidate) =>
    toNumber(candidate?.total_correct) + toNumber(candidate?.programming_points);

export const getCandidateStatusLabel = (candidate, passPercentage = 92) => {
    if (candidate?.final_result === 'pass') {
        return 'PASS';
    }

    if (candidate?.final_result === 'fail') {
        return 'FAIL';
    }

    if (candidate?.passed === 1) {
        return 'PASS';
    }

    if (candidate?.passed === 0) {
        return 'FAIL';
    }

    const percentage = Number.parseFloat(candidate?.percentage);
    if (Number.isFinite(percentage)) {
        return percentage >= passPercentage ? 'PASS' : 'FAIL';
    }

    const attemptedQuestions = Math.max(toNumber(candidate?.total_attempted), 1);
    const fallbackPercentage = (toNumber(candidate?.total_correct) / attemptedQuestions) * 100;

    return fallbackPercentage >= passPercentage ? 'PASS' : 'FAIL';
};

export const escapeCsvValue = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
